import Button from '@jetbrains/ring-ui/components/button/button'
import ButtonGroup from '@jetbrains/ring-ui/components/button-group/button-group'
import type {MouseEvent} from 'react'
import * as React from 'react'

import {useAppSelector} from '../../../../../../../hooks/react-redux'
import {ShowFeedbackFormReasons} from '../Feedback.slice'

import FeedbackFormSection from './FeedbackForm.section'

import styles from './FeedbackForm.css'

type Props = {
  onRatingSelect: (rating: number) => void
}

const ratings = {
  2: '😡',
  4: '😞',
  6: '🙂',
  8: '☺️',
  10: '🥰',
}

function FeedbackFormRating({onRatingSelect}: Props) {
  const [rating, setLocalRating] = React.useState(0)
  const reason = useAppSelector(state => state.pipelines.feedbackForm.visibility.reason)

  // How do you find using the Pipelines?
  const setRating = React.useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      const value = parseInt(event.currentTarget?.dataset?.value || '0', 10)
      setLocalRating(value)

      onRatingSelect(value)
    },
    [onRatingSelect],
  )

  return (
    <FeedbackFormSection
      title={
        reason === ShowFeedbackFormReasons.FOLLOW_UP
          ? 'How do you find using the Pipelines?'
          : 'How easy was it to set up your pipeline?'
      }
      text={
        reason === ShowFeedbackFormReasons.FOLLOW_UP
          ? ''
          : 'Share your feedback and help us create a platform that makes your everyday tasks easier and more convenient.'
      }
    >
      <div className={styles.valuesContainer}>
        <ButtonGroup className={styles.values}>
          {Object.entries(ratings).map(([v, emoji]) => {
            const value = parseInt(v, 10)
            return (
              <Button
                key={value}
                onClick={setRating}
                data-value={value}
                active={rating === value}
                className={styles.value}
              >
                {emoji}
              </Button>
            )
          })}
        </ButtonGroup>
        <div className={styles.hints}>
          <span className={styles.hint}>{'Very complicated'}</span>
          <span className={styles.hint}>{'Intuitive and easy'}</span>
        </div>
      </div>
    </FeedbackFormSection>
  )
}

export default React.memo(FeedbackFormRating)
